/**
 * EDIT THIRD PARTY REDUX ACTIONS
 *
 * @version 0.1
 */

import xhr from '../utils/xhr';
import { experianPageSize } from "../constants";

const api = {
    loadCompanyData: (companyId) => {
        return xhr.get({
            url: '/api/entities/company/' + companyId
        }).then((response) => {
            return response.body;
        })
    },

    saveCompanyData: (companyData) => {
        return xhr.put({
            url:  '/api/entities/company/' + companyData.id,
            data: companyData
        }).then((response) => {
            return response.body;
        });
    },

    toggleEntityActivation: (companyData) => {
        return xhr.put({
            url:  '/api/entities/riskentity/' + companyData.id + '/status/' + companyData.active,
            data: companyData
        }).then((response) => {
            return response.body;
        });
    },

    addNewCategory: (category) => {
        return xhr.post({
            url:  '/api/categories/',
            data: {
                name: category
            }
        });
    },

    queryExperian: (experian, page = 0) => {
        const pageRange = (experianPageSize * page + 1) + "/" + ((experianPageSize * (page + 1)))
        return xhr.get({
            url: `/api/experian/by-query/${experian}/${pageRange}`,
        });
    },

    queryEsExperian: (experian) => {
        return xhr.post({
            url: `/api/experian/by-es-query`,
            data: experian
        });
    },

    queryExperianId: (experian, entityId) => {
        if (entityId) {
            return xhr.get({
                url: `/api/experian/by-experian-id-and-entity-id/${experian}/${entityId}`,
            });
        } else {
            return xhr.get({
                url: `/api/experian/by-experian-id/${experian}`,
            });
        }
    },


};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/EditThirdParty.api.js